import { SET_CONFIG } from './constants';

const INITIAL_STATE = {
  apiUrl: '',
  apiKey: '',
  tenant: '',
  messageLimit: null,
  messageFlagEnabled: true,
  homeContentStyle: {},
  homeContentClass: '',
  pageTitle: '',
  logo: '',
};

const configReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_CONFIG:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default configReducer;
